<ion-item>
  <ion-label>{{ field.label }}</ion-label>
</ion-item>
<!-- {{field|json}}
<ng-container *ngIf="cFormArray">
  <ng-container *ngFor="let group of cFormArray.controls">
    <ng-container *ngIf="group | asFormGroupPipe as formGroup">
      <ng-container *ngIf="formGroup.controls['value'] | asFormControlPipe as formControl">
        <ion-item [disabled]="disabledField" [ngClass]="{'gl-disable-invisible': disabledField}">
          <ion-toggle color="success" [formControl]="formControl" class="gl-style-label">
            <ng-container *ngIf="formGroup.controls['label'] as labelControl">
              {{ labelControl.value }}
            </ng-container>
          </ion-toggle>
        </ion-item>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container> -->
<ng-container *ngIf="cFormArray">
  <ng-container *ngFor="let group of cFormArray.controls; let i = index">
    <ng-container *ngIf="group | asFormGroupPipe as formGroup">
      <ng-container *ngIf="formGroup.controls['value'] | asFormControlPipe as formControl">
        <ion-item
          [disabled]="
            disabledField || 
            (field.pre_requis === true && i > 0 && !cFormArray.at(i - 1).get('value')?.value)
          "
          [ngClass]="{'gl-disable-invisible': disabledField}">
          <ion-toggle
            color="success"
            [formControl]="formControl"
            class="gl-style-label">
            <ng-container *ngIf="formGroup.controls['label'] as labelControl">
              {{ labelControl.value }}
            </ng-container>
          </ion-toggle>
        </ion-item>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

